import { useEffect, useState } from "react";
import { billSplitsService } from "./useBill.service";

export const useBillSplitData = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecord, setTotalRecord] = useState(0);
  const [pagination, setPagination] = useState(0);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    fromDate: null,
    toDate: null,
    splitMethod: null,
    server: null,
    table: null,
    page: null,
    pageSize: 15,
  });
  const [orgTableList, setOrgTableList] = useState([]);
  const [orgSectionList, setSectionList] = useState([]);
  const [employees, setEmployees] = useState([]);

  const getData = async (filters) => {
    setLoading(true);
    setData([]);
    setTotalRecord(0);
    setPagination({});
    try {
      const { data: response } = await billSplitsService.getBillSplitOrdersList(
        filters
      );
      if (response.success) {
        console.log("Bill Splits Data:", response.data.items);
        setData(response.data.items);
        console.log("Pagination Data:", data);
        setTotalRecord(response.data.pagination.total);
        setPagination({
          currentPage: response.data.pagination.current_page,
          perPage: response.data.pagination.per_page,
          lastPage: response.data.pagination.last_page,
          nextPageUrl: response.data.pagination.links.next,
          prevPageUrl: response.data.pagination.links.prev,
          total: response.data.pagination.total,
        });
      }
    } catch (error) {
      console.error("Error fetching bill splits:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const getOrgEmployees = async () => {
    try {
      const { data: response } = await billSplitsService.getOrgEmployees();

      if (response.success) {
        setEmployees(response.data);
      }
    } catch (error) {
      console.error("Error fetching Employees:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const getOrganizationTableList = async () => {
    try {
      const { data: response } =
        await billSplitsService.getOrganizationTableList();
      if (response.success) {
        setOrgTableList(response.data);
        console.log("Organization Table List:", response.data);
      }
    } catch (error) {
      console.error("Error fetching Organization Table List:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };
  const getSectionTableList = async () => {
    try {
      const { data: response } = await billSplitsService.getSectionList();
      if (response.success) {
        setSectionList(response.data);
        console.log("Section List:", response.data);
      }
    } catch (error) {
      console.error("Error fetching Organization Table List:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };
  const BillReportDownload = async () => {
    try {
     
      setError(null);

      const { data: response } =
        await billSplitsService.getBillSplitDownloadUrl(filters);

      if (response.success) {
        // Create invisible link and click it
        const link = document.createElement("a");
        link.href = response.data.url;

        // Remove the download attribute to let server determine filename
        // OR extract filename from URL/response if available
        // link.download = '';

        link.setAttribute("target", "_blank"); // Fallback for some browsers
        link.style.display = "none";
        document.body.appendChild(link);

        // More reliable click method
        if (typeof link.click === "function") {
          link.click();
        } else {
          // Fallback for older browsers
          const event = new MouseEvent("click", {
            view: window,
            bubbles: true,
            cancelable: true,
          });
          link.dispatchEvent(event);
        }

        // Clean up with delay for older browsers
        setTimeout(() => {
          if (document.body.contains(link)) {
            document.body.removeChild(link);
          }
        }, 100);
      }
    } catch (error) {
      console.error("Error downloading bill report:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Initial data fetch can be triggered here if needed
    const fetchData = async () => {
      await getData(filters);
      // await getOrgEmployees();
      //  / await getOrganizationTableList();
    };
    const fetchFilterData = async () => {
      // await getData(filters);
      await getOrgEmployees();
      await getOrganizationTableList();
      await getSectionTableList();
    };
    fetchFilterData();
    fetchData();
  }, [filters]); // Re-fetch data when filters change

  return {
    filters,
    setFilters,
    error,
    data,
    loading,
    totalRecord,
    pagination,
    employees,
    orgTableList,
    BillReportDownload,
    orgSectionList,
  };
};
